import { useWeb3 } from "@chainsafe/web3-context";
import { ChevronDownIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/menu";
import { Box, Button, Flex, Link, Text } from "@chakra-ui/react";
import { BoldText } from "../../Components/UI/UIHelpers";
import { shortenAddress } from "../../Utils/Helpers";
import { networkNameByNetworkId, networkIds } from "../../chainbridgeConfig";
import { getFeatureFlagStatus } from "../../featureFlags";

const walletExtendedActionsEnabled = getFeatureFlagStatus(
  "walletExtendedActionsEnabled"
);
const trackerUrl = process.env.REACT_APP_TRACKER_URL;
const networks = networkIds();

export const UserProfile = () => {
  const {
    checkIsReady,
    onboard,
    wallet,
    address,
    network,
    resetOnboard,
    switchNetwork,
  } = useWeb3();

  const handleConnect = async () => {
    !wallet && (await onboard?.walletSelect());
    wallet && (await checkIsReady());
  };

  // Allow to switch b/w two networks - Palm and Ethereum (for Token Bridge)
  const changeNetwork = () => {
    switchNetwork(network === networks[1] ? networks[0] : networks[1]);
  };

  const isUnsupportedNetwork = (): boolean => {
    return !!network && networkNameByNetworkId(network) === "Unsupported";
  };

  return (
    <>
      <Box>
        {!address ? (
          <Button
            fullsize="true"
            onClick={() => {
              handleConnect();
            }}
          >
            Connect Wallet
          </Button>
        ) : (
          <Menu gutter={0} matchWidth={true}>
            <MenuButton
              as={Button}
              fontSize="12px"
              p={0}
              variant="outline"
              rightIcon={<ChevronDownIcon w={6} h={6} mr={2} />}
            >
              <Flex alignItems="center" py="8px" px="10px">
                <Box
                  w="10px"
                  h="10px"
                  bgColor={
                    isUnsupportedNetwork()
                      ? "palmNetwork.900"
                      : "palmNetwork.1000"
                  }
                  borderRadius="50%"
                  mr="10px"
                />
                <BoldText>{address && shortenAddress(address)}</BoldText>
              </Flex>
            </MenuButton>
            <MenuList borderRadius="0px" border="1px solid">
              {network && (
                <Text
                  p={1}
                  px={3}
                  color={
                    isUnsupportedNetwork()
                      ? "palmNetwork.900"
                      : "palmNetwork.1000"
                  }
                >
                  Network: {networkNameByNetworkId(network)}
                </Text>
              )}
              {address && (
                <MenuItem key="transactions">
                  <Link href={`${trackerUrl}?address=${address}`} isExternal>
                    My Transfers <ExternalLinkIcon />
                  </Link>
                </MenuItem>
              )}
              {walletExtendedActionsEnabled && onboard && (
                <MenuItem key="check-wallet">
                  <span onClick={onboard?.walletCheck}>Check Wallet</span>
                </MenuItem>
              )}
              {walletExtendedActionsEnabled && (
                <MenuItem key="reset-wallet">
                  <span onClick={resetOnboard}>Reset Wallet</span>
                </MenuItem>
              )}
              {walletExtendedActionsEnabled && (
                <MenuItem key="change-config">
                  <span onClick={changeNetwork}>Change Network</span>
                </MenuItem>
              )}
            </MenuList>
          </Menu>
        )}
      </Box>
    </>
  );
};
